import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardNamn } from 'src/app/shared/models/standard-namn';
import { NameType } from '../../../shared/models/models';
import { Synonym } from '../../../shared/models/synonymer';
import { StandardNamnService } from '../../standard-namn/standard-namn.service';

interface StandardNamnFormModel {
  name: string;
  id: string;
}

@Component({
    selector: 'lib-synonymer-edit-dialog',
    templateUrl: './synonymer-edit-dialog.component.html',
    styleUrls: ['./synonymer-edit-dialog.component.css'],
    standalone: false
})
export class SynonymerEditDialogComponent implements OnInit {
  synonym!: Synonym;
  nameType!: NameType;
  standardNamnList: StandardNamn[] = [];

  form!: FormGroup;

  constructor(
    protected config: DynamicDialogConfig,
    protected ref: DynamicDialogRef,
    protected standardNamnService: StandardNamnService
  ) {}

  ngOnInit(): void {
    this.synonym = this.config.data?.synonym;
    this.nameType = this.config.data?.nameType;

    this.form = new FormGroup({
      comment: new FormControl(this.synonym.comments),
      selectedStandardNamn: new FormControl<StandardNamnFormModel | null>(null, Validators.required),
    });

    this.getStandardnamn(this.nameType);
  }

  private getStandardnamn(type: NameType) {
    this.standardNamnService.getStandardNamnByType(type, true)?.subscribe(list => this.standardNamnList = list);
  }

  save() {
    const modifiedSynonym = {
      ...this.synonym,
      name: this.form.value.selectedStandardNamn,
      comments: this.form.value.comment
     }
    this.ref.close(modifiedSynonym);
  }

  close() {
    this.ref.close();
  }
}
